import { configureMarkdown, parseMarkdown, getMarkdown, extendMarkdown } from 'genesysmarkdown';
/*!
 * Markdown Plugin
 */
Genesys('registerPlugin', 'Markdown', (Markdown) => {
  /* Register Commands */

  /**
  *
  * Initializes the markdown library with a set of rules we want.
  * Calling this command is optional. It can also take options that can over-ride the current default settings if needed.
  *
  */

  Markdown.registerCommand('configure', e => {
    const { enabled } = e.data || {};

    if (typeof enabled === 'boolean') {
      configureMarkdown(e.data);
      e.resolve();
    } else {
      e.reject('A boolean `enabled` is required');
    }
  });

  /**
  *
  * Parse the input string using the rules provided during initialization and returns the html marked content.
  *
  */

  Markdown.registerCommand('parse', e => {
    const { text } = e.data || '';

    //if no text is present then reject
    if (text && text !== '') {
      const value = parseMarkdown(e.data);

      if (!value) {
        return e.reject();
      } else {
        return e.resolve(value);
      }
    } else {
      return e.reject('A string `text` is required to parse the markdown content');
    }
  });

  /**
  *
  * Parse the input string using the rules provided during initialization and return the html marked content along with a boolean to indicate if a link is included within the content.
  *
  */

  Markdown.registerCommand('getMarkdown', e => {
    const { text } = e.data || '';

    //if no text is present then reject
    if (text && text !== '') {
      const value = getMarkdown(e.data);

      if (typeof value !== 'object' || !value) {
        return e.reject();
      } else {
        return e.resolve(value);
      }
    } else {
      return e.reject('A string `text` is required to get the markdown content');
    }
  });

  /**
  *
  * To extend writing custom marked syntaxes using markdown extensions.
  *
  */
  Markdown.registerCommand('extend', e => {
    const { extensions } = e.data || [];

    //if no extension is present then reject
    if (extensions && extensions.length) {
      extendMarkdown(e.data);
      e.resolve();
    } else {
      e.reject('An array `extensions` containing markdown extension is required');
    }
  });

  Markdown.ready();
});
